













































































import Vue from "vue";
import { Advertiser } from "../../interfaces/advertiser";
import { mapGetters, mapState } from "vuex";
import AppFormLogicMixin from "@/plugins/AppFormLogicMixin";

export default Vue.extend({
  mixins: [AppFormLogicMixin],
  methods: {
    async loadAdvertiser() {
      this.updateAdvertiser = await this.$store.dispatch("get", [
        this.my().advertiser
      ]);
      this.isLoading = false;
    },
    onComplete() {
      this.$router.push({
        name: "AdvertiserEditComplete"
      });
    }
  },
  mounted() {
    this.$store.dispatch("fetchPrefectures");
    this.loadAdvertiser();
  },
  computed: {
    ...mapState(["prefectures"]),
    ...mapGetters(["my"]),
    rawPostData(): Partial<Advertiser> {
      return this.updateAdvertiser;
    },
    validateUrl(): string {
      return this.my().advertiser + "/validate";
    },
    execUrl(): string {
      return this.my().advertiser;
    },
    execMethod(): string {
      return "patch";
    }
  },
  data() {
    return {
      isLoading: true,
      phase: "input",
      updateAdvertiser: {} as Partial<Advertiser>,
      violations: {}
    };
  }
});
